import { IconButton } from '@material-ui/core';

import {
  ContactInfo,
  BillingSection,
  ReasonsForContact,
  UserTag,
} from './components';
import { ReactComponent as MsgOutlineIcon } from 'assets/images/icons/message_outline.svg';
import { ReactComponent as PhoneOutlineIcon } from 'assets/images/icons/phone_outline.svg';

import { useClientInfoModule } from './hooks';
import makeClasses from './ClientInfoModule.style';

import type { OrderId } from 'shared/domain';

export function ClientInfoModule({ orderId = NaN }: Props) {
  const {
    isRender,
    lang,
    isMarketplace,
    user,
    showChatBtn,
    showPhoneCallBtn,
    showFooter,
    showReasons,
    showContactInfo,
    showPhone,
    showAddress,
    showBillingInfo,
    handlePhoneCallBtn,
    handleSupportChatBtn,
    handleReasonSubstitution,
    handleReasonOther,
  } = useClientInfoModule({ orderId });

  const _classes = makeClasses();

  if (isRender) return null;
  return (
    <article className={_classes.article} data-is-marketplace={isMarketplace}>
      <header>
        <h1 className={_classes.title}>{lang.header.title}</h1>
      </header>

      <main className={_classes.main}>
        <section aria-label='user-section' className={_classes.userSection}>
          <div aria-label='user-tags'>
            {user.tag.isNew && <UserTag variant='new' />}
            {user.tag.isPro && <UserTag variant='pro' />}
          </div>
          <h2 aria-label='user-name'>{user.name.basic}</h2>
        </section>

        <section aria-label='actions' className={_classes.actions}>
          {showPhoneCallBtn && (
            <IconButton
              onClick={handlePhoneCallBtn}
              classes={{ root: _classes.action }}
            >
              <PhoneOutlineIcon aria-label='icon' />
            </IconButton>
          )}
          {showChatBtn && (
            <IconButton
              onClick={handleSupportChatBtn}
              classes={{ root: _classes.action }}
            >
              <MsgOutlineIcon aria-label='icon' />
            </IconButton>
          )}
        </section>
      </main>

      {showReasons && (
        <ReasonsForContact
          handleReasonSubstitution={handleReasonSubstitution}
          handleReasonOther={handleReasonOther}
        />
      )}

      {showFooter && (
        <footer className={_classes.footer}>
          {showContactInfo && (
            <ContactInfo
              showPhone={showPhone}
              showAddress={showAddress}
              user={user}
            />
          )}
          {showBillingInfo && <BillingSection user={user} />}
        </footer>
      )}
    </article>
  );
}

interface Props {
  orderId: OrderId;
}
